import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { CheckHasWatchlistApproversUseCase } from './CheckHasWatchlistApproversUseCase'

export const checkHasWatchlistApprovers = new CheckHasWatchlistApproversUseCase(
  {
    expenseRepository,
  }
).execute
